import type { RootState } from '..';
import { createSelector, createStructuredSelector } from 'reselect';

/**
 * @param state the RootState
 * @returns Will always be the root user id, even if the user is masquerading.
 */
export const getRootUser = (state: RootState): RootState['auth']['user'] => {
    return state.auth.user;
};

/**
 * @param state the RootState
 * @returns Will be the masqueraded user id, if the user is masquerading.
 */
export const getUser = (state: RootState): RootState['auth']['user'] => state.auth.masqUser ?? state.auth.user;

const getAuthAccessToken = (state: RootState) => state.auth.accessToken;
const getAuthMasqAccessToken = (state: RootState) => state.auth.masqAccessToken;

export const getAccessTokens = createStructuredSelector({
    accessToken: getAuthAccessToken,
    masqAccessToken: getAuthMasqAccessToken,
});

export const getClientCredentials = (state: RootState): RootState['auth']['clientCredentials'] =>
    state.auth.clientCredentials;

export const getCurrentAccessToken = createSelector(getAccessTokens, (tokens) => {
    return tokens?.masqAccessToken?.token ?? tokens?.accessToken?.token;
});

export const getIsSuperuserEnabledFlag = (state: RootState): RootState['ui']['superuserAccessEnabledUntil'] =>
    state.ui.superuserAccessEnabledUntil;
export const getCurrentIsSuperuserEnabledFlag = createSelector(getIsSuperuserEnabledFlag, (flag) => Boolean(flag));
